import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import PropTypes from 'prop-types';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimelineFilterGroupV2 = ({
  checked,
  children,
  label,
  handleGroupClick,
  indeterminate
}) => {
  return /*#__PURE__*/_jsxs(View, {
    paddingInlineEnd: "200",
    paddingBlockEnd: "300",
    as: "div",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: checked,
      indeterminate: indeterminate,
      onChange: handleGroupClick,
      paddingInlineStart: "100",
      paddingBlockStart: "600",
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Text, {
        textTransform: "uppercase",
        as: "h6",
        children: label
      })
    }), children]
  });
};
TimelineFilterGroupV2.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  handleGroupClick: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  indeterminate: PropTypes.bool.isRequired
};
export default TimelineFilterGroupV2;